var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6502 6.96191C16.436 6.96191 16.2617 7.1362 16.2617 7.35035C16.2617 7.56451 16.436 7.73879 16.6502 7.73879C16.8643 7.73879 17.0386 7.56454 17.0386 7.35035C17.0386 7.13616 16.8643 6.96191 16.6502 6.96191Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9983 8.55713C10.0995 8.55713 8.55469 10.1019 8.55469 12.0008C8.55469 13.8996 10.0995 15.4444 11.9983 15.4444C13.8972 15.4444 15.442 13.8996 15.442 12.0008C15.442 10.102 13.8972 8.55713 11.9983 8.55713Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6138 4H8.38616C5.96762 4 4 5.96763 4 8.38619V15.6138C4 18.0324 5.96762 20 8.38616 20H15.6138C18.0324 20 20 18.0324 20 15.6138V8.38619C20 5.96763 18.0324 4 15.6138 4ZM12 16.3885C9.58016 16.3885 7.61153 14.4198 7.61153 12C7.61153 9.58016 9.58019 7.61156 12 7.61156C14.4198 7.61156 16.3885 9.58019 16.3885 12C16.3885 14.4198 14.4198 16.3885 12 16.3885ZM16.651 8.68237C15.9158 8.68237 15.3177 8.08425 15.3177 7.34906C15.3177 6.61387 15.9158 6.01572 16.651 6.01572C17.3862 6.01572 17.9843 6.61384 17.9843 7.34903C17.9843 8.08422 17.3862 8.68237 16.651 8.68237Z",
    fill: "currentColor"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8b77c26c43dacb02d9608d012072cd0c.svg";
export { ForwardRef as ReactComponent };